import { Injectable } from '@angular/core';

export interface VerifiedCheckinPhone {
  phoneNumber: string;
  dialCode: string;
  countryCode?: string;
  userId?: string;
  memberId?: number;
  verificationToken?: string;
}
export interface CheckinSignupContext extends VerifiedCheckinPhone {
  tenant: string;
  returnUrl: string;
  verifiedAt: number;
}

export function isCheckinReturnUrl(url: string, tenant: string): boolean {
  if (tenant && url === '/' + tenant + '/fast-checkin') return true;
  return !!tenant && url?.startsWith('/' + tenant + '/') &&
    /^\/[A-Za-z0-9_-]+\/(?:qr-self-checkin|qr-self-checkin-fixed|qr-self-checkin-fixed-group|qr-self-checkin-fixed-venue)\/[1-9]\d*$/.test(url);
}

// Phone proofs stay in memory, never in URLs or persistent browser storage.
@Injectable({ providedIn: 'root' })
export class SelfCheckinFlowService {
  private context?: CheckinSignupContext;
  begin(tenant: string, returnUrl: string, phone: VerifiedCheckinPhone): boolean {
    const path = returnUrl.split(/[?#]/)[0];
    if (!isCheckinReturnUrl(path, tenant) || !phone.verificationToken) return false;
    this.context = {...phone, tenant, returnUrl: path, verifiedAt: Date.now()};
    return true;
  }
  read(tenant: string): CheckinSignupContext | undefined {
    return this.context?.tenant === tenant ? this.context : undefined;
  }
  verified(tenant: string): CheckinSignupContext | undefined {
    const context = this.read(tenant);
    return context && Date.now() - context.verifiedAt < 29 * 60 * 1000 ? context : undefined;
  }
  clear(): void { this.context = undefined; }
}
